import { v4 } from 'uuid';

import { API_CONTEXT, config, SOURCE_SYSTEM, targetEnv } from '../config';
import { CYBERSOURCE_MERCHANT_ID } from '../constants/domain-specific';
import { selectIsReferral } from '../selectors/selectAppDetails';
import type { RootState } from '../store';
import { API } from '../types/enums';

function getReferralContext(state: RootState): string {
  const groups = state.appDetails?.groups;
  const includedGroups = ['costco', 'thriday', 'velocity'];
  const group = Array.isArray(groups) ? groups.find((g) => includedGroups.includes(g)) : undefined;
  if (group) {
    return `digi${group}`;
  }
  return API_CONTEXT;
}

export const defaultHeadersFactory =
  ({ api }: { api: API }) =>
  (
    headers: Headers,
    {
      getState,
    }: {
      getState: () => unknown;
    }
  ) => {
    if (api === API.Sitecore) return headers;

    const state = getState() as RootState;
    const context = selectIsReferral(state) ? getReferralContext(state) : API_CONTEXT;
    headers.set('X-SourceSystem', SOURCE_SYSTEM);
    headers.set('X-TrackingID', `${v4()}-${targetEnv}`);
    headers.set('X-Api-Context', context);
    headers.set('X-Partner-Context', context);
    /** @note MS to change this from a string to a boolean */
    headers.set('X-Mockable', 'false');
    headers.set('X-MerchantID', CYBERSOURCE_MERCHANT_ID);

    api === API.Payments && headers.set('X-TargetOrigin', config.origin);

    return headers;
  };

export const defaultHeadersCommercialInsurance = defaultHeadersFactory({
  api: API.CommercialInsurance,
});
export const defaultHeadersPayments = defaultHeadersFactory({
  api: API.Payments,
});
export const defaultHeadersSitecore = defaultHeadersFactory({
  api: API.Sitecore,
});
